export default {
  appName: "Sep Dashboard",

  // Navigation
  navigation: {
    dashboard: "Bảng điều khiển",
    leads: "Lead",
    opportunities: "Bán hàng",
    customers: "Khách hàng",
    organizations: "Tổ chức",
    inbasket: "Danh sách công việc",
    manuals: "Hướng dẫn sử dụng",
    profile: "Hồ sơ",

    // Sidebar menu labels (different from breadcrumb)
    sidebar: {
      Opportunity: "Bán hàng",
    },
    // Dynamic item types - exact Aras ItemType names
    // Core ItemTypes
    Lead: "Lead",
    Lead_plural: "Leads",
    Leads: "Leads",
    Opportunity: "Cơ hội bán hàng",
    Opportunity_plural: "Cơ hội bán hàng",
    Customer: "Khách hàng",
    Customer_plural: "Khách hàng",
    Organization: "Tổ chức",
    Organization_plural: "Tổ chức",
    Address: "Địa chỉ",
    Address_plural: "Địa chỉ",
    Person: "Người liên hệ",
    Person_plural: "Người liên hệ",
    Contact: "Liên hệ",
    Contact_plural: "Liên hệ",

    // Internal/Support ItemTypes
    Department: "Phòng ban",
    Department_plural: "Phòng ban",
    Position: "Vị trí",
    Position_plural: "Vị trí",
    Task: "Nhiệm vụ",
    Task_plural: "Nhiệm vụ",
    Product: "Sản phẩm",
    Product_plural: "Sản phẩm",
    Employee: "Nhân sự",
    Employee_plural: "Nhân sự",
    Referrer: "Người giới thiệu",
    Referrer_plural: "Người giới thiệu",
    Document: "Tài liệu",
    Document_plural: "Tài liệu",
    Campaign: "Chiến dịch",
    Campaign_plural: "Chiến dịch",

    // Education & Facility ItemTypes
    EducationFacility: "Cơ sở giáo dục",
    EducationFacility_plural: "Cơ sở giáo dục",
    Facility: "Cơ sở vật chất",
    Facility_plural: "Cơ sở vật chất",

    // Lead ItemTypes
    ServiceNeed: "Nhu cầu dịch vụ",
    ServiceNeed_plural: "Nhu cầu dịch vụ",

    // Customer ItemTypes
    CustomerTier: "Hạng khách hàng",
    CustomerTier_plural: "Hạng khách hàng",
    PricingPolicy: "Chính sách giá",
    PricingPolicy_plural: "Chính sách giá",

    // Sales ItemTypes
    Proposal: "Đề xuất",
    Proposal_plural: "Đề xuất",
    Contract: "Hợp đồng",
    Contract_plural: "Hợp đồng",

    // Operations ItemTypes
    Class: "Lớp học",
    Class_plural: "Lớp học",
    Student: "Học sinh",
    Student_plural: "Học sinh",
    Attendance: "Điểm danh",
    Attendance_plural: "Điểm danh",
    Revenue: "Nguồn thu",
    Revenue_plural: "Nguồn thu",

    // Care ItemTypes
    CarePlan: "Cơ chế chăm sóc",
    CarePlan_plural: "Cơ chế chăm sóc",
    CareActivity: "Hoạt động CSKH",
    CareActivity_plural: "Hoạt động CSKH",

    // Geographic (List ItemTypes displayed as items)
    Province: "Tỉnh/Thành phố",
    Province_plural: "Tỉnh/Thành phố",
    District: "Quận/Huyện",
    District_plural: "Quận/Huyện",
    Ward: "Phường/Xã",
    Ward_plural: "Phường/Xã",

    // Legacy lowercase keys (keep for backward compatibility)
    addresses: "Địa chỉ",
    persons: "Người",
    workflows: "Workflow",
    "workflow-maps": "Workflow Map",
    contacts: "Liên hệ",
    products: "Sản phẩm",
    campaigns: "Chiến dịch",
    contracts: "Hợp đồng",
    proposals: "Đề xuất",
    invoices: "Hóa đơn",
    projects: "Dự án",
    tasks: "Công việc",
    activities: "Hoạt động",
    departments: "Phòng ban",
    positions: "Vị trí",
    employees: "Nhân sự",
    referrers: "Người giới thiệu",
    documents: "Tài liệu",
    educationFacilities: "Cơ sở giáo dục",
    facilities: "Cơ sở vật chất",
    serviceNeeds: "Nhu cầu dịch vụ",
    customerTiers: "Hạng khách hàng",
    pricingPolicies: "Chính sách giá",
    classes: "Lớp học",
    students: "Học sinh",
    attendances: "Điểm danh",
    revenues: "Nguồn thu",
    carePlans: "Cơ chế chăm sóc",
    careActivities: "Hoạt động CSKH",
    provinces: "Tỉnh/Thành phố",
    districts: "Quận/Huyện",
    wards: "Phường/Xã",
  },

  // Auth
  auth: {
    signIn: "Đăng nhập",
    signInToAccount: "Đăng nhập vào tài khoản của bạn",
    username: "Tên đăng nhập",
    userPass: "Mật khẩu",
    enterUsername: "Nhập tên đăng nhập",
    enterPass: "Nhập mật khẩu",
    loginFailed: "Đăng nhập thất bại",
    usernameRequired: "Vui lòng nhập tên đăng nhập",
    passRequired: "Vui lòng nhập mật khẩu",
    logout: "Đăng xuất",
    // Error messages
    invalidCredentials: "Tên đăng nhập hoặc mật khẩu không đúng",
    accountDisabled: "Tài khoản đã bị vô hiệu hóa",
    tooManyAttempts: "Quá nhiều lần đăng nhập thất bại. Vui lòng thử lại sau",
    serverError: "Lỗi máy chủ. Vui lòng thử lại sau",
    networkError:
      "Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối mạng",
    mfa: {
      verifyTitle: "Xác thực hai yếu tố",
      enterCode: "Nhập mã 6 chữ số từ ứng dụng xác thực",
      enterBackupCode: "Nhập một trong các mã dự phòng",
      backupCodePlaceholder: "ABCD1234",
      verify: "Xác nhận",
      trustDevice: "Tin tưởng thiết bị này trong 30 ngày",
      useBackupCode: "Sử dụng mã dự phòng",
      useAuthenticator: "Sử dụng ứng dụng xác thực",
      backToLogin: "Quay lại đăng nhập",
      invalidCode: "Mã xác thực không hợp lệ",
      codeExpired: "Phiên xác thực đã hết hạn. Vui lòng đăng nhập lại",
      tooManyAttempts: "Quá nhiều lần thử. Vui lòng đăng nhập lại",
      setupTitle: "Thiết lập xác thực hai yếu tố",
      scanQrCode: "Quét mã QR này bằng ứng dụng xác thực",
      manualEntry: "Hoặc nhập khóa thủ công",
      confirmSetup: "Nhập mã hiển thị trên ứng dụng để xác nhận",
      setupSuccess: "Đã bật xác thực hai yếu tố thành công",
      backupCodesTitle: "Mã dự phòng",
      backupCodesInfo:
        "Lưu các mã này ở nơi an toàn. Mỗi mã chỉ sử dụng được một lần.",
      backupCodesRemaining: "Còn {{count}} mã dự phòng",
      regenerateBackupCodes: "Tạo lại mã dự phòng",
      copyAll: "Sao chép tất cả",
      download: "Tải xuống",
      enabled: "Xác thực hai yếu tố đã được bật",
      disabled: "Xác thực hai yếu tố chưa được bật",
      enable: "Bật 2FA",
      disable: "Tắt 2FA",
      securityTitle: "Bảo mật tài khoản",
      disableConfirm: "Nhập mã hiện tại để tắt 2FA",
      regenerateConfirm: "Nhập mã hiện tại để tạo lại mã dự phòng",
      enrollmentRequired:
        "Tổ chức của bạn yêu cầu xác thực hai yếu tố. Vui lòng thiết lập 2FA để tiếp tục.",
    },
  },

  // Dashboard
  dashboard: {
    welcomeBack: "Chào mừng trở lại, {{name}}!",
    placeholder: {
      title: "Dashboard sắp ra mắt",
      description:
        "Đây là dashboard tạm thời. Cấu hình biến VITE_DASHBOARD_TYPE để bật các module dashboard cụ thể.",
      configure: "Cấu hình",
      getStarted: "Bắt đầu",
      feature1: "Tính năng 1",
      feature1Desc: "Mô tả tính năng 1",
      feature2: "Tính năng 2",
      feature2Desc: "Mô tả tính năng 2",
      feature3: "Tính năng 3",
      feature3Desc: "Mô tả tính năng 3",
    },
    overview: "Tổng quan hoạt động kinh doanh của bạn",
    totalLeads: "Leads",
    leads: "Leads",
    opps: "Cơ hội",
    customers: "KH",
    tasks: "Việc",
    pendingTasks: "Công việc chờ xử lý",
    pipelineValue: "Giá trị pipeline",
    conversionRate: "Tỷ lệ chuyển đổi",
    opportunities: "Cơ hội bán hàng",
    totalCustomers: "Khách hàng",
    recentLeads: "Leads gần đây",
    recentOpportunities: "Cơ hội bán hàng gần đây",
    viewAll: "Xem tất cả",
    noLeadsYet: "Chưa có khách hàng tiềm năng",
    noPendingTasks: "Không có công việc chờ xử lý",
    noOpportunities: "Chưa có cơ hội bán hàng",
    noEmail: "Không có email",
    noDueDate: "Không có ngày đến hạn",
    due: "Hạn: {{date}}",
    newLead: "Tạo Lead mới",
    leadsThisMonth: "{{count}} lead mới gần đây",
    tasksToday: "Cần xử lý ngay",
    activity: "Hoạt động",
    itemType: "Loại",
    salesPipeline: "Quy trình bán hàng",
    topOpportunities: "Cơ hội hàng đầu",
    overdue: "Quá hạn",
    inPeriod: "trong kỳ",
  },

  // Table columns
  table: {
    id: "Mã",
    name: "Tên",
    company: "Công ty",
    email: "Email",
    phone: "Điện thoại",
    priority: "Độ ưu tiên",
    status: "Trạng thái",
    value: "Giá trị",
    state: "Trạng thái",
    actions: "Thao tác",
    siteId: "Chi nhánh",
    customer: "Khách hàng",
    stage: "Giai đoạn",
    amount: "Số tiền",
    probability: "Xác suất",
    segment: "Phân khúc",
    city: "Thành phố",
    type: "Loại",
    source: "Nguồn",
    dueDate: "Ngày đến hạn",
    searchPlaceholder: "Nhập thông tin để tìm kiếm...",
    allFields: "Tất cả",
    selectFilter: "Chọn...",
    searchName: "Tìm kiếm tên",
    industry: "Ngành nghề",
    size: "Quy mô",
    employees: "Nhân viên",
    country: "Quốc gia",
    // InBasket columns
    sourceItem: "Mục nguồn",
    activity: "Hoạt động",
    startDate: "Ngày bắt đầu",
    assignedTo: "Được giao cho",
    instructions: "Hướng dẫn",
    assigned_sales_id: "Sales phụ trách",
    education_facility: "Cơ sở giáo dục",
    item_number: "Mã",
    itemNumber: "Mã",
    // Column settings
    columns: "Cột",
    columnSettings: "Cài đặt cột",
    noData: "Không có dữ liệu",
    resetColumns: "Đặt lại mặc định",
    // Boolean checkbox
    checkAll: "Chọn tất cả",
    uncheckAll: "Bỏ chọn tất cả",
    selectAll: "Tất cả",
  },

  // Priority
  priority: {
    high: "Cao",
    medium: "Trung bình",
    low: "Thấp",
  },

  // Status
  status: {
    new: "Mới",
    contacted: "Đã liên hệ",
    qualified: "Đủ điều kiện",
    negotiation: "Đàm phán",
    won: "Thắng",
    lost: "Thua",
    active: "Hoạt động",
    inactive: "Không hoạt động",
    prospect: "Tiềm năng",
    churned: "Đã rời bỏ",
    draft: "Bản nháp",
    pending: "Đang chờ",
  },

  // Stage
  stage: {
    qualification: "Đánh giá",
    needsAnalysis: "Phân tích nhu cầu",
    proposal: "Đề xuất",
    negotiation: "Đàm phán",
    closedWon: "Đã đóng - Thắng",
    closedLost: "Đã đóng - Thua",
  },

  // Segment
  segment: {
    enterprise: "Doanh nghiệp",
    smb: "SMB",
    startup: "Startup",
    individual: "Cá nhân",
  },

  // Buttons for Refine
  buttons: {
    create: "Tạo mới",
    save: "Lưu",
    edit: "Chỉnh sửa",
    delete: "Xóa",
    cancel: "Hủy",
    confirm: "Xác nhận",
    list: "Danh sách",
    show: "Xem",
    refresh: "Làm mới",
    add: "Thêm",
    addExisting: "Thêm từ danh sách",
    createNew: "Tạo mới",
    populateFrom: "Lấy từ {{source}}",
    populating: "Đang lấy dữ liệu...",
    view: "Xem",
    download: "Tải xuống",
    change: "Thay đổi",
    close: "Đóng",
    select: "Chọn",
    yes: "Có",
    no: "Không",
    clear: "Xóa",
    filter: "Lọc",
    confirmDelete: "Hành động này không thể hoàn tác.",
    preview: "Xem trước",
    selectFile: "Chọn file",
    duplicate: "Tạo bản sao",
  },

  // Actions
  actions: {
    show: "Xem",
    edit: "Chỉnh sửa",
    delete: "Xóa",
    create: "Tạo mới",
    save: "Lưu",
    cancel: "Hủy",
    complete: "Duyệt",
    ok: "Đồng ý",
    confirm: "Xác nhận",
    duplicate: "Tạo bản sao",
  },

  // Page titles
  titles: {
    editLead: "Chỉnh sửa Lead",
    showLead: "Chi tiết Lead",
    editOpportunity: "Chỉnh sửa Cơ hội",
    showOpportunity: "Chi tiết Cơ hội",
    editCustomer: "Chỉnh sửa Khách hàng",
    showCustomer: "Chi tiết Khách hàng",
    editOrganization: "Chỉnh sửa Tổ chức",
    showOrganization: "Chi tiết Tổ chức",
  },

  // Workflow / InBasket
  workflow: {
    // InBasket item types
    workflowTask: "Tác vụ",

    // InBasket
    inbasket: "Danh sách công việc",
    completeTask: "Duyệt công việc",
    activityCompletion: "Duyệt hoạt động công việc",
    workflowName: "Workflow",
    activity: "Hoạt động",
    task: "Công việc",
    item: "Mục",
    vote: "Chọn đường dẫn",
    selectPath: "Chọn đường dẫn để duyệt công việc này:",
    selectPathPlaceholder: "Chọn đường dẫn",
    comments: "Ghi chú",
    commentsPlaceholder: "Nhập ghi chú (không bắt buộc)...",
    taskCompleted: "Công việc duyệt thành công",
    taskCompletedDescription:
      "Công việc đã được duyệt và chuyển sang bước tiếp theo.",
    taskFailed: "Không thể duyệt công việc",
    taskFailedDescription:
      "Có lỗi xảy ra khi duyệt công việc. Vui lòng thử lại.",
    pathNotFound: "Không tìm thấy đường dẫn",
    pathNotFoundDescription:
      "Không tìm thấy đường dẫn workflow. Vui lòng thử lại.",
    totalItems: "Tổng {{total}} mục",
    // Workflow Visualization
    button: "Quy trình",
    title: "Quy trình công việc",
    noWorkflow: "Chưa có quy trình",
    startedBy: "Khởi tạo bởi",
    activeDate: "Ngày kích hoạt",
    closedDate: "Ngày đóng",
    processOwner: "Chủ sở hữu",
    legend: {
      start: "Bắt đầu",
      completed: "Hoàn thành",
      active: "Đang xử lý",
      pending: "Chờ xử lý",
      end: "Kết thúc",
      auto: "Tự động",
    },
    backToList: "Quay về danh sách",
    voteCompletedTitle: "Duyệt thành công",
    // Workflow History Report
    history: {
      title: "Quy trình",
      reportTitle: "Báo cáo lịch sử quy trình",
      item: "Mục",
      currentStatus: "Trạng thái hiện tại",
      startedBy: "Khởi tạo bởi",
      startedOn: "Ngày bắt đầu",
      completedOn: "Ngày hoàn thành",
      activity: "Hoạt động",
      state: "Trạng thái",
      assignedTo: "Được giao cho",
      completedBy: "Hoàn thành bởi",
      howVoted: "Kết quả",
      when: "Thời gian",
      comments: "Ghi chú",
      voteNow: "DUYỆT",
      noWorkflow: "Mục này chưa có quy trình",
      exportExcel: "Xuất Excel",
      exportWord: "Xuất Word",
    },
  },

  // Lifecycle
  lifecycle: {
    title: "Trạng thái vòng đời",
    status: "Trạng thái vòng đời",
    completed: "đã hoàn thành",
    current: "Hiện tại",
    pending: "Chờ xử lý",
    noLifecycle: "Không có thông tin vòng đời",
    statesCompleted: "{{completed}} / {{total}} đã hoàn thành",
    availableActions: "Thao tác có sẵn",
    promoteTo: "Chuyển sang {{state}}",
    confirmPromotion: "Xác nhận chuyển đổi",
    confirmPromoteMessage:
      "Bạn có chắc chắn muốn chuyển mục này sang <strong>{{state}}</strong>?",
    promotedSuccess: "Đã chuyển mục sang {{state}}",
    promoteFailed: "Không thể chuyển mục",
    promoting: "Đang chuyển...",
  },

  // Kanban board
  kanban: {
    viewMode: "Kanban",
    uncategorized: "Chưa phân loại",
    items: "{{count}} mục",
    items_one: "1 mục",
    noItems: "Không có mục",
    notAvailable: "Chế độ Kanban không khả dụng",
    promoteSuccess: "Đã chuyển sang {{state}}",
    promoteError: "Không thể chuyển trạng thái",
    voteTitle: "Cần bỏ phiếu Workflow",
    voteSuccess: "Đã bỏ phiếu: {{path}}",
    voteError: "Không thể bỏ phiếu",
    transitionNotAllowed: "Không thể chuyển trực tiếp từ {{from}} sang {{to}}",
    showingLimit:
      "Đang hiển thị {{count}} mục đầu tiên. Sử dụng bộ lọc để thu hẹp.",
  },

  // Assignment
  assignment: {
    title: "Phân công",
    owner: "Chủ sở hữu",
    assignedTo: "Được giao cho",
  },

  // Language
  language: {
    switch: "Chuyển ngôn ngữ",
    vi: "Tiếng Việt",
    en: "English",
  },

  // Pagination
  pagination: {
    total: "Tổng {{total}} mục",
  },

  // Forms
  forms: {
    leadInformation: "Thông tin khách hàng tiềm năng",
    customerInformation: "Thông tin khách hàng",
    opportunityInformation: "Thông tin cơ hội",
    opportunity: "Cơ hội",
    organizationInformation: "Thông tin tổ chức",
    parentOrganization: "Tổ chức mẹ",
    contactInformation: "Thông tin liên hệ",
    companyInformation: "Thông tin công ty",
    notes: "Ghi chú",
    dates: "Ngày tháng",
    relatedEntities: "Đối tượng liên quan",

    // Labels
    id: "Mã",
    name: "Tên",
    priority: "Độ ưu tiên",
    source: "Nguồn",
    expectedCloseDate: "Ngày dự kiến đóng",
    estimatedValue: "Giá trị ước tính",
    currency: "Tiền tệ",
    description: "Mô tả",
    contactName: "Tên liên hệ",
    position: "Chức vụ",
    email: "Email",
    phone: "Điện thoại",
    companyName: "Tên công ty",
    industry: "Ngành nghề",
    website: "Website",
    created: "Ngày tạo",
    lastModified: "Cập nhật lần cuối",
    expectedClose: "Ngày dự kiến đóng",
    lastContact: "Liên hệ lần cuối",
    actualClose: "Ngày đóng thực tế",
    stage: "Giai đoạn",
    type: "Loại",
    amount: "Số tiền",
    probability: "Xác suất",
    status: "Trạng thái",
    segment: "Phân khúc",
    rating: "Đánh giá",
    lead: "Lead",
    customer: "Khách hàng",
    organization: "Tổ chức",
    totalRevenue: "Tổng doanh thu",
    firstPurchase: "Mua hàng lần đầu",
    lastPurchase: "Mua hàng lần cuối",
    address: "Địa chỉ",
    city: "Thành phố",
    country: "Quốc gia",
    postalCode: "Mã bưu điện",

    // Placeholders
    selectPriority: "Chọn độ ưu tiên",
    selectSource: "Chọn nguồn",
    selectIndustry: "Chọn ngành nghề",
    selectStage: "Chọn giai đoạn",
    selectType: "Chọn loại",
    selectSegment: "Chọn phân khúc",
    selectSize: "Chọn quy mô",
    selectRating: "Chọn đánh giá",
    selectStatus: "Chọn trạng thái",
    addNotes: "Thêm ghi chú về khách hàng tiềm năng này...",
    addNotesCustomer: "Thêm ghi chú về khách hàng này...",
    addNotesOpportunity: "Thêm ghi chú về cơ hội này...",
    addNotesOrganization: "Thêm ghi chú về tổ chức này...",

    // Validation
    nameRequired: "Tên là bắt buộc",
    invalidEmail: "Email không hợp lệ",
    invalidUrl: "URL không hợp lệ",

    assigned_sales_id: "Sales phụ trách",
    item_number: "Mã",
    itemNumber: "Mã",

    // Additional sections for Dynamic Form
    addressInformation: "Thông tin địa chỉ",
    basicInformation: "Thông tin cơ bản",
  },

  // Sources
  sources: {
    website: "Website",
    referral: "Giới thiệu",
    socialMedia: "Mạng xã hội",
    tradeShow: "Triển lãm",
    coldCall: "Gọi điện trực tiếp",
    other: "Khác",
  },

  // Industries
  industries: {
    technology: "Công nghệ",
    education: "Giáo dục",
    healthcare: "Y tế",
    finance: "Tài chính",
    retail: "Bán lẻ",
    manufacturing: "Sản xuất",
    other: "Khác",
  },

  // Aras Value Lists (List_* translations)
  lists: {
    // Marketing Lists
    marketingChannel: {
      _label: "Kênh Marketing",
      online: "Trực tuyến",
      offline: "Ngoại tuyến",
      social_media: "Mạng xã hội",
      email: "Email",
      event: "Sự kiện",
      referral: "Giới thiệu",
      direct: "Trực tiếp",
      partner: "Đối tác",
      advertising: "Quảng cáo",
      other: "Khác",
    },
    leadSource: {
      _label: "Nguồn Lead",
      website: "Website",
      facebook: "Facebook",
      zalo: "Zalo",
      google: "Google",
      referral: "Giới thiệu",
      event: "Sự kiện",
      cold_call: "Gọi điện",
      partner: "Đối tác",
      advertising: "Quảng cáo",
      email_campaign: "Chiến dịch email",
      trade_show: "Triển lãm",
      word_of_mouth: "Truyền miệng",
      other: "Khác",
    },
    productAwareness: {
      _label: "Nhận biết sản phẩm",
      yes: "Có",
      no: "Không",
    },
    leadClassification: {
      _label: "Phân loại Lead",
      hot: "Nóng",
      warm: "Ấm",
      cold: "Lạnh",
    },
    leadEligibility: {
      _label: "Sự phù hợp",
      eligible: "Phù hợp",
      not_eligible: "Không phù hợp",
    },
    interactionStatus: {
      _label: "Trạng thái tương tác",
      new: "Mới",
      contacted: "Đã liên hệ",
      interested: "Quan tâm",
      not_interested: "Không quan tâm",
      follow_up: "Theo dõi",
      qualified: "Đủ điều kiện",
      unqualified: "Không đủ điều kiện",
      converted: "Đã chuyển đổi",
      lost: "Mất",
    },

    // Status Lists
    workStatus: {
      _label: "Trạng thái công việc",
      not_started: "Chưa bắt đầu",
      in_progress: "Đang thực hiện",
      completed: "Hoàn thành",
      on_hold: "Tạm dừng",
      cancelled: "Đã hủy",
      pending: "Đang chờ",
    },
    salesStatus: {
      _label: "Trạng thái sale",
      active: "Hoạt động",
      inactive: "Không hoạt động",
    },
    salesMethod: {
      _label: "Hình thức sale",
      direct: "Trực tiếp",
      online: "Trực tuyến",
      phone: "Điện thoại",
      email: "Email",
      partner: "Đối tác",
      event: "Sự kiện",
    },
    approvalStatus: {
      _label: "Trạng thái phê duyệt",
      pending: "Đang chờ",
      approved: "Đã duyệt",
      rejected: "Từ chối",
      revision: "Cần sửa đổi",
      cancelled: "Đã hủy",
    },
    infoStatus: {
      _label: "Trạng thái thông tin",
      draft: "Bản nháp",
      active: "Hoạt động",
      inactive: "Không hoạt động",
    },
    paymentStatus: {
      _label: "Trạng thái thanh toán",
      pending: "Chờ thanh toán",
      paid: "Đã thanh toán",
      overdue: "Quá hạn",
    },
    documentStatus: {
      _label: "Tình trạng hồ sơ",
      draft: "Bản nháp",
      submitted: "Đã nộp",
      approved: "Đã duyệt",
      rejected: "Từ chối",
      archived: "Lưu trữ",
    },
    classStatus: {
      _label: "Trạng thái lớp học",
      planning: "Lên kế hoạch",
      active: "Đang hoạt động",
      completed: "Hoàn thành",
      cancelled: "Đã hủy",
      suspended: "Tạm ngưng",
    },
    customerStatus: {
      _label: "Trạng thái khách hàng",
      prospect: "Tiềm năng",
      active: "Hoạt động",
      inactive: "Không hoạt động",
      churned: "Đã rời bỏ",
      suspended: "Tạm ngưng",
    },

    // Sales Lists
    opportunitySalesStage: {
      _label: "Giai đoạn bán hàng",
      prospecting: "Tìm kiếm",
      discovery: "Khám phá",
      demo: "Demo",
      proposal: "Đề xuất",
      negotiation: "Đàm phán",
      closed_won: "Đã đóng - Thắng",
      closed_lost: "Đã đóng - Thua",
      on_hold: "Tạm dừng",
    },
    proposalStatus: {
      _label: "Trạng thái đề xuất",
      draft: "Bản nháp",
      sent: "Đã gửi",
      viewed: "Đã xem",
      accepted: "Chấp nhận",
      rejected: "Từ chối",
      expired: "Hết hạn",
      revised: "Đã sửa đổi",
      cancelled: "Đã hủy",
    },
    contractStatus: {
      _label: "Trạng thái hợp đồng",
      draft: "Bản nháp",
      reviewing: "Đang xem xét",
      pending: "Chờ ký",
      active: "Hiệu lực",
      suspended: "Tạm ngưng",
      expired: "Hết hạn",
      terminated: "Chấm dứt",
      renewed: "Đã gia hạn",
    },
    contractType: {
      _label: "Loại hợp đồng",
      new: "Mới",
      renewal: "Gia hạn",
      amendment: "Sửa đổi",
      termination: "Chấm dứt",
      other: "Khác",
    },

    // Product & Service Lists
    product: {
      _label: "Sản phẩm/Dịch vụ",
      teaching: "Giảng dạy",
      event: "Sự kiện",
      gotrip: "GoTrip",
      sportweek: "Tuần thể thao",
      teacher_training: "Đào tạo GV",
      franchise: "Nhượng quyền",
      demo_class: "Lớp demo",
      demo_school: "Trường demo",
      coaching: "Huấn luyện",
      observation: "Quan sát",
      enrollment: "Tuyển sinh",
      playground: "Sân chơi",
    },
    documentType: {
      _label: "Loại tài liệu",
      contract: "Hợp đồng",
      proposal: "Đề xuất",
      invoice: "Hóa đơn",
      report: "Báo cáo",
      certificate: "Chứng chỉ",
      license: "Giấy phép",
      agreement: "Thỏa thuận",
      letter: "Thư",
      form: "Biểu mẫu",
      manual: "Hướng dẫn",
      policy: "Chính sách",
      procedure: "Quy trình",
      presentation: "Thuyết trình",
      image: "Hình ảnh",
      video: "Video",
      audio: "Âm thanh",
      spreadsheet: "Bảng tính",
      database: "Cơ sở dữ liệu",
      archive: "Lưu trữ",
      other: "Khác",
    },

    // Operation Lists
    studentStatus: {
      _label: "Tình trạng học sinh",
      active: "Đang học",
      inactive: "Nghỉ học",
    },
    studentType: {
      _label: "Đối tượng học sinh",
      regular: "Thường",
      scholarship: "Học bổng",
      special: "Đặc biệt",
    },
    facilityCondition: {
      _label: "Điều kiện CSVC",
      good: "Tốt",
      needs_repair: "Cần sửa chữa",
    },
    location: {
      _label: "Địa điểm học",
      school: "Tại trường",
      center: "Tại trung tâm",
      outdoor: "Ngoài trời",
    },
    coachType: {
      _label: "Loại HLV",
      lead: "HLV Lead",
      support: "HLV Hỗ trợ",
      intern: "Thực tập",
      guest: "Khách mời",
    },

    // Care Lists
    careAction: {
      _label: "Hành động CSKH",
      call: "Gọi điện",
      visit: "Thăm viếng",
      email: "Gửi email",
      gift: "Tặng quà",
      event: "Mời sự kiện",
    },
    careItem: {
      _label: "Hạng mục CSKH",
      birthday: "Sinh nhật",
      holiday: "Ngày lễ",
      regular: "Định kỳ",
    },
    careResult: {
      _label: "Kết quả CSKH",
      successful: "Thành công",
      partial: "Một phần",
      unsuccessful: "Không thành công",
    },

    // Industry Lists
    industry: {
      _label: "Ngành nghề KD",
      education: "Giáo dục",
      healthcare: "Y tế",
      technology: "Công nghệ",
      finance: "Tài chính",
      retail: "Bán lẻ",
      manufacturing: "Sản xuất",
      construction: "Xây dựng",
      real_estate: "Bất động sản",
      hospitality: "Khách sạn/Du lịch",
      transportation: "Vận tải",
      agriculture: "Nông nghiệp",
      energy: "Năng lượng",
      media: "Truyền thông",
      consulting: "Tư vấn",
      legal: "Pháp lý",
      government: "Chính phủ",
      nonprofit: "Phi lợi nhuận",
      sports: "Thể thao",
      entertainment: "Giải trí",
      food_beverage: "Thực phẩm/Đồ uống",
      fashion: "Thời trang",
      other: "Khác",
    },
    businessType: {
      _label: "Loại hình KD",
      private: "Tư nhân",
      public: "Công",
      state_owned: "Nhà nước",
      joint_venture: "Liên doanh",
      foreign: "Nước ngoài",
      cooperative: "Hợp tác xã",
      household: "Hộ kinh doanh",
      individual: "Cá nhân",
      ngo: "Tổ chức phi chính phủ",
      association: "Hiệp hội",
      other: "Khác",
    },

    // Education Lists
    educationLevel: {
      _label: "Trình độ GD",
      preschool: "Mầm non",
      primary: "Tiểu học",
      secondary: "Trung học cơ sở",
      high_school: "Trung học phổ thông",
      vocational: "Nghề",
      college: "Cao đẳng",
      university: "Đại học",
    },

    // Other Lists
    yesNoUnknown: {
      _label: "Có/Không/Chưa rõ",
      yes: "Có",
      no: "Không",
      unknown: "Chưa rõ",
    },
    personType: {
      _label: "Loại người liên hệ",
      owner: "Chủ sở hữu",
      manager: "Quản lý",
      principal: "Hiệu trưởng",
      teacher: "Giáo viên",
      parent: "Phụ huynh",
      other: "Khác",
    },
  },

  // Site scoping
  site: {
    title: "Chi nhánh",
    allSites: "Tất cả chi nhánh",
    selectSite: "Chọn chi nhánh",
    currentSite: "Chi nhánh hiện tại",
    noSite: "Chưa phân chi nhánh",
    headquarters: "Trụ sở chính",
    yourSite: "Chi nhánh của bạn: {{site}}",
  },

  // Tabs
  tabs: {
    details: "Thông tin",
  },

  // Common
  common: {
    loading: "Đang tải...",
    noData: "-",
    normal: "Bình thường",
    yes: "Có",
    no: "Không",
    on: "Bật",
    off: "Tắt",
    totalItems: "Tổng {{total}} mục",
    noItems: "Không tìm thấy mục nào",
    version: "Phiên bản",
  },

  // Fields (for dynamic table columns)
  fields: {
    name: "Tên",
    itemNumber: "Mã",
    state: "Trạng thái",
    filename: "Tên file",
    fileSize: "Kích thước",
    comments: "Ghi chú",
    createdOn: "Ngày tạo",
    relatedItem: "Mục liên quan",
    sortOrder: "Thứ tự",
    file: "File",
  },

  // Placeholders
  placeholders: {
    comments: "Nhập ghi chú (không bắt buộc)",
    sortOrder: "Nhập thứ tự",
  },

  // Messages
  messages: {
    loading: "Đang tải...",
    previewNotSupported: "Không thể xem trước loại tệp này",
    success: "Thành công",
  },

  // Errors
  errors: {
    fetchFailed: "Không thể tải dữ liệu",
    resourceNotFound: "Không tìm thấy tài nguyên: {{resource}}",
    metadataFailed: "Không thể tải cấu hình bảng",
    metadataFailedDesc: "Vui lòng thử lại hoặc liên hệ hỗ trợ.",
    validationError: "Lỗi xác thực",
    selectFile: "Vui lòng chọn file",
    uploadFailed: "Tải lên thất bại",
    unknownError: "Đã xảy ra lỗi không xác định",
  },

  // Dynamic Form
  dynamicForm: {
    fieldRequired: "{{field}} là bắt buộc",
    maxLength: "Tối đa {{max}} ký tự",
    invalidFormat: "Định dạng không hợp lệ",
    invalidEmail: "Địa chỉ email không hợp lệ",
    invalidUrl: "URL không hợp lệ",
    enter: "Nhập {{field}}",
    select: "Chọn {{field}}",
    selectDate: "Chọn ngày",
    selectDateTime: "Chọn ngày và giờ",
    selectTime: "Chọn giờ",
    selectItem: "Chọn {{itemType}}",
    selectMultiple: "Chọn một hoặc nhiều {{field}}",
    noItemsFound: "Không tìm thấy mục nào",
    enterImageUrl: "Nhập URL hình ảnh",
    autoGenerated: "Tự động tạo",
    metadataError: "Không thể tải cấu hình biểu mẫu",
    usingFallback: "Đang sử dụng cấu hình mặc định",
    additionalFields: "Thông tin bổ sung",
    // Add new related item
    addNew: "Thêm mới {{itemType}}",
    createNew: "Tạo {{itemType}} mới",
    loadingMetadata: "Đang tải biểu mẫu...",
    createError: "Không thể tạo mục",
    createSuccess: "Đã tạo {{itemType}} thành công",
    // File upload
    existingFile: "File hiện có",
    fileTooLarge: "Kích thước file vượt quá giới hạn {{maxSize}}",
    fileUploaded: "Đã tải lên {{fileName}} thành công",
    uploadFailed: "Tải lên thất bại",
    downloadFailed: "Tải xuống thất bại",
    previewFailed: "Xem trước thất bại",
    loadingFile: "Đang tải thông tin file...",
    uploading: "Đang tải lên...",
    uploadHint: "Nhấn hoặc kéo file vào đây để tải lên",
    uploadMaxSize: "Kích thước file tối đa: {{maxSize}}",
    replaceFile: "Thay thế file",
    noFormConfigured: "Form chưa được cấu hình",
    noFormConfiguredDesc: "Vui lòng liên hệ quản trị viên để thiết lập form.",
  },

  // Notifications (Refine default keys)
  notifications: {
    // Create
    createSuccess: "Tạo thành công",
    createError: "Lỗi khi tạo",
    // Edit/Update
    editSuccess: "Cập nhật thành công",
    editError: "Lỗi khi cập nhật",
    // Delete
    deleteSuccess: "Xóa thành công",
    deleteError: "Lỗi khi xóa",
    // Populate
    populateSuccess: "Đã thêm {{count}} mục thành công",
    populatePartialSuccess:
      "Đã thêm {{count}} mục (một số nguồn không tải được)",
    populateError: "Không thể lấy dữ liệu",
    populateNoSource: "Không tìm thấy {{source}} liên kết",
    populateNoItems: "Không có mục nào trong {{source}}",
    populateAllExist: "Tất cả mục đã có trong danh sách",
    // Bulk add
    bulkAddSuccess: "Đã thêm {{count}} mục thành công",
    // Errors
    error: "Đã xảy ra lỗi",
    undoable: "Bạn có {{seconds}} giây để hoàn tác",
    success: "Thành công",
    // HTTP Error messages
    httpError: {
      400: "Yêu cầu không hợp lệ",
      401: "Phiên đăng nhập đã hết hạn",
      403: "Bạn không có quyền thực hiện thao tác này",
      404: "Không tìm thấy dữ liệu",
      408: "Yêu cầu đã hết thời gian chờ",
      409: "Xung đột dữ liệu. Vui lòng làm mới và thử lại",
      422: "Dữ liệu không hợp lệ",
      429: "Quá nhiều yêu cầu. Vui lòng thử lại sau",
      500: "Lỗi máy chủ. Vui lòng thử lại sau",
      502: "Không thể kết nối đến máy chủ",
      503: "Dịch vụ tạm thời không khả dụng",
      504: "Máy chủ không phản hồi",
      default: "Đã xảy ra lỗi. Vui lòng thử lại",
    },
    networkError:
      "Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối mạng",
    requestFailed: "Yêu cầu thất bại",
  },

  // User Manuals
  manuals: {
    title: "Hướng dẫn sử dụng",
    fullscreen: "Toàn màn hình",
    exitFullscreen: "Thoát toàn màn hình",
    notFound: "Không tìm thấy tài liệu",
    notFoundHint: "Không tìm thấy file hướng dẫn tại {{file}}",
    items: {
      qlcv: "Hướng dẫn quản lý công việc",
      hrm: "Hướng dẫn quản lý nhân sự",
      fieldDefinitions: "Từ điển dữ liệu CRM",
    },
  },

  // Profile
  profile: {
    title: "Hồ sơ cá nhân",
    edit: "Chỉnh sửa",
    changeCredential: "Đổi mật khẩu",
    personalInformation: "Thông tin cá nhân",
    companyInformation: "Thông tin công ty",
    accountSettings: "Cài đặt tài khoản",

    // Fields
    loginName: "Tên đăng nhập",
    firstName: "Tên",
    lastName: "Họ",
    fullName: "Họ và tên",
    email: "Email",
    telephone: "Điện thoại",
    cell: "Di động",
    fax: "Fax",
    pager: "Máy nhắn tin",
    homePhone: "Điện thoại nhà",
    companyName: "Tên công ty",
    employeeNumber: "Mã nhân viên",
    mailStop: "Mail Stop",
    manager: "Quản lý",
    logonEnabled: "Cho phép đăng nhập",
    startingPage: "Trang bắt đầu",
    defaultVault: "Kho mặc định",
    workingDirectory: "Thư mục làm việc",

    // Placeholders
    enterFirstName: "Nhập tên",
    enterLastName: "Nhập họ",
    enterEmail: "Nhập email",
    enterTelephone: "Nhập số điện thoại",
    enterCell: "Nhập số di động",

    // Credential fields
    currentCredential: "Mật khẩu hiện tại",
    newCredential: "Mật khẩu mới",
    confirmCredential: "Xác nhận mật khẩu",
    enterCurrentCredential: "Nhập mật khẩu hiện tại",
    enterNewCredential: "Nhập mật khẩu mới",
    enterConfirmCredential: "Nhập lại mật khẩu mới",

    // Validation
    currentCredentialRequired: "Vui lòng nhập mật khẩu hiện tại",
    newCredentialRequired: "Vui lòng nhập mật khẩu mới",
    confirmCredentialRequired: "Vui lòng xác nhận mật khẩu",
    credentialMinLength: "Mật khẩu phải có ít nhất 6 ký tự",
    credentialMismatch: "Mật khẩu xác nhận không khớp",

    // Messages
    fetchError: "Không thể tải thông tin hồ sơ",
    updateSuccess: "Cập nhật hồ sơ thành công",
    updateError: "Không thể cập nhật hồ sơ",
    credentialChangeSuccess: "Đổi mật khẩu thành công",
    credentialChangeError: "Không thể đổi mật khẩu",
  },

  // Import
  import: {
    button: "Import",
    title: "Import dữ liệu",

    // Steps
    steps: {
      upload: "Tải file",
      mapping: "Ánh xạ cột",
      preview: "Xem trước",
      result: "Kết quả",
    },

    // Upload
    dragDropText: "Kéo thả file vào đây hoặc click để chọn",
    supportedFormats: "Hỗ trợ: Excel (.xlsx, .xls) và CSV (.csv)",
    downloadTemplate: "Tải template mẫu",
    templateHint: "Sử dụng template để đảm bảo đúng format",
    viewSupportedFields: "Xem danh sách trường hỗ trợ",
    templateExcel: "Template Excel (.xlsx)",
    templateCSV: "Template CSV (.csv)",
    noResponsiveForm: "Item type này chưa có responsive form layout",

    // Mapping
    fileColumn: "Cột trong file",
    targetField: "Trường đích",
    selectField: "Chọn trường...",
    ignoreColumn: "Bỏ qua cột này",
    requiredFieldsMissing: "Một số trường bắt buộc chưa được ánh xạ:",
    mappingHint:
      "Ánh xạ các cột trong file với các trường của hệ thống. Hệ thống đã tự động nhận diện một số cột.",
    status: "Trạng thái",

    // Preview
    totalRows: "Tổng số dòng",
    validRows: "Hợp lệ",
    invalidRows: "Có lỗi",
    validationErrorsFound: "Phát hiện {{count}} lỗi validation",

    // Result
    importSuccess: "Import thành công!",
    importPartial: "Import hoàn tất với một số lỗi",
    importFailed: "Import thất bại",
    created: "Đã tạo",
    failed: "Thất bại",
    downloadErrors: "Tải danh sách lỗi",

    // Update existing records
    updateExisting: "Cập nhật bản ghi trùng lặp",
    updateExistingDesc:
      "Nếu bật, các dòng trùng item_number hoặc name sẽ được cập nhật thay vì bỏ qua hoặc báo lỗi",
    updated: "Đã cập nhật",
    updatedItems: "Các mục đã cập nhật",

    // Skip duplicates
    skipDuplicates: "Bỏ qua bản ghi trùng lặp",
    skipDuplicatesDesc:
      "Nếu bật, các dòng có item_number hoặc name đã tồn tại trong hệ thống sẽ được bỏ qua",
    skipped: "Bỏ qua",
    skippedDuplicates: "Bản ghi trùng lặp đã bỏ qua",
    matchField: "Trường trùng",
    matchValue: "Giá trị",
    existingId: "ID đã tồn tại",
    importAllSkipped: "Tất cả bản ghi đã tồn tại",

    // Auto-create references
    autoCreateReferences: "Tự động tạo dữ liệu tham chiếu",
    autoCreateReferencesDesc:
      "Nếu bật, các bản ghi tham chiếu không tìm thấy sẽ được tạo tự động trong hệ thống",
    autoCreatedReferences: "Dữ liệu tham chiếu đã tạo tự động",
    refItemType: "Loại",
    refName: "Tên",
    refField: "Trường",
    andMore: "và",
    moreItems: "mục khác",

    // Errors
    errors: {
      invalidFormat:
        "Định dạng file không hỗ trợ. Chỉ chấp nhận .xlsx, .xls, .csv",
      invalidMimeType: "Loại file không hợp lệ",
      fileTooLarge: "File quá lớn. Kích thước tối đa là 10MB",
      emptyFile: "File rỗng",
      noHeaders: "File không có header columns",
      noData: "File không có dữ liệu",
      tooManyRows: "File có quá nhiều dòng. Tối đa 1000 dòng mỗi lần import",
      required: "Trường bắt buộc",
      invalidEmail: "Email không hợp lệ",
      invalidDate: "Ngày không hợp lệ",
      invalidNumber: "Số không hợp lệ",
      parseError: "Không thể đọc file. Vui lòng kiểm tra định dạng",
    },

    // Result details
    row: "Dòng",
    createdItems: "Các mục đã tạo",
    itemNumber: "Mã số",
    orgCode: "Mã nội bộ",
    name: "Tên",
    successMessage: "Import thành công: {{count}} mục đã được import",
    failedMessage:
      "Import thất bại: {{count}} dòng có lỗi. Xem chi tiết bên dưới.",
    allSkippedMessage: "Tất cả {{count}} bản ghi đã tồn tại và được bỏ qua.",
    templateDownloaded: "Template đã được tải xuống",

    // Buttons
    next: "Tiếp tục",
    back: "Quay lại",
    import: "Import",
    done: "Hoàn tất",
    cancel: "Hủy",
  },

  // Empty State
  emptyState: {
    noData: "Không có dữ liệu",
    noDataDescription: "Chưa có dữ liệu để hiển thị.",
    noItems: "Chưa có {{resource}}",
    createFirst: "Bắt đầu bằng cách tạo {{resource}} đầu tiên.",
  },

  // Quick Filter
  quickFilter: {
    all: "Tất cả",
  },

  // Time Range
  timeRange: {
    today: "Hôm nay",
    "7days": "7 ngày qua",
    "30days": "30 ngày qua",
    quarter: "Quý này",
    all: "Tất cả",
    label: "Khoảng thời gian",
  },

  // Theme
  theme: {
    toggle: "Chuyển giao diện sáng/tối",
    light: "Giao diện sáng",
    dark: "Giao diện tối",
  },

  // Bottom Navigation
  bottomNav: {
    lists: "Danh sách",
  },

  // Relationships
  relationships: {
    title: "Mục liên quan",
  },

  // Item Picker Modal
  itemPicker: {
    searchPlaceholder: "Tìm kiếm theo tên, mã, hoặc mô tả...",
    searchByColumn: "Tìm kiếm theo {{column}}...",
    allColumns: "Tất cả cột",
    selectedCount: "Đã chọn {{count}} mục",
    noItems: "Không tìm thấy mục nào",
  },

  // Org Chart
  orgChart: {
    noData: "Không có dữ liệu phòng ban",
    departments: "phòng ban",
    rootDepartments: "gốc",
  },

  // Manager Assignment (Task 32)
  manager: {
    modalTitle: "Gán người quản lý",
    role: "Vai trò",
    selectRole: "Chọn vai trò",
    roleRequired: "Vui lòng chọn vai trò",
    newManager: "Người quản lý mới",
    selectUser: "Chọn người dùng",
    newManagerRequired: "Vui lòng chọn người quản lý",
    effectiveFrom: "Ngày bắt đầu",
    effectiveFromRequired: "Vui lòng chọn ngày bắt đầu",
    effectiveTo: "Đến ngày",
    endReason: "Lý do kết thúc nhiệm kỳ hiện tại",
    endReasonDefault: "Mặc định: Thay thế",
    notes: "Ghi chú",
    manager: "Người quản lý",
    currentTenure: "Đang nhiệm kỳ",
    noHistory: "Chưa có lịch sử bổ nhiệm quản lý",
    noIncumbent: "Vị trí này hiện chưa có người đảm nhiệm.",
    incumbentTitle: "Vị trí đã có người đảm nhiệm",
    incumbentSince: "đang giữ vị trí này từ",
    incumbentConfirm:
      "Xác nhận sẽ kết thúc nhiệm kỳ hiện tại và bắt đầu nhiệm kỳ mới.",
    confirmReplace: "Xác nhận thay đổi",
    confirmAssign: "Gán người quản lý",
    assignSuccess: "Người quản lý đã được cập nhật",
    conflictRetry:
      "Vị trí này vừa được người khác cập nhật. Vui lòng kiểm tra lại người đương nhiệm.",
    historyTabTitle: "Lịch sử quản lý",
    changeButton: "Thay đổi người quản lý",
    currentManager: "Quản lý hiện tại",
    vacant: "Chưa có",
  },
};
